<template>
  <component :is="wrapComp.component" :class="get(wrapComp,'params.props.class')||{}" :style="get(wrapComp,'params.props.style')||{}">
    <component v-if="labelText" :is="labelComp.component" :class="get(labelComp,'params.props.class')||{}" :style="get(labelComp,'params.props.style')||{}">{{labelText}} </component>
    <component :is="tabComp.component" :class="get(tabComp,'params.props.class')||{}" :style="get(tabComp,'params.props.style')||{}">
      <component :is="tabNameComp.component" v-for="(tabName, index) in tabNames" :class="[{active:currentIndexShowChildren==index},get(tabNameComp,'params.props.class')||{}]"
                 :style="get(tabNameComp,'params.props.style')||{}" @click="currentIndexShowChildren=index" :key="index">
        <input v-if="isRadio" type="radio" :checked="currentIndexShowChildren==index">
        <label>{{tabName}}</label>
      </component>
    </component>
    <slot></slot>
  </component>
</template>

<script>
    import {get} from 'lodash'
    export default {
      name: "tab-layout",
      props:{
        wrapComp:{
          type:Object,
          default:()=>{
            return {
              "component":'div',
            }
          }
        },
        tabComp:{
          type:Object,
          default:()=>{
            return {
              "component":'div',
              "params":{
                "props":{
                  //"class":"ui basic buttons"
                  "class":"ui attached tabular menu"
                }
              }
            }
          }
        },
        initIndexShowChildren:{
          type:Number,
          default:0
        },
        tabNames:{
          type:Array,
          default:[]
        },
        tabNameComp:{
          type:Object,
          default:()=>{
            return {
              "component":'div',
              "params":{
                "props":{
                  //"class":"ui button"
                  "class":"item"
                }
              }
            }
          }
        },
        labelComp:{
          type:Object,
          default:()=>{
            return {
              "component":'span',
            }
          }
        },
        labelText:{
          type:String,
        },
        isRadio:{
          type:Boolean,
          default:false
        }
      },
      data () {
        return {
          currentIndexShowChildren:this.initIndexShowChildren,
        };
      },
      methods:{
        get(object,prop){
          return get(object,prop);
        }
      },
      watch:{
        currentIndexShowChildren:{
          immediate:true,
          handler(newValue){
            this.$emit('jsonLayoutChangeIndexShowChildren',newValue)
          }
        },

      }
    }
</script>

<style scoped>

</style>
